import finsightWebUrl from '@/finsight/infrastructure/finsightWebUrl';
import config from '@finsight/config';

const baseSchema = {
  '@context': 'https://schema.org/',
  publisher: {
    '@type': 'Organization',
    name: 'Finsight',
    url: finsightWebUrl.getUrl(),
    telephone: config.supportPhoneNumber,
    email: config.supportEmail,
  },
};

export default baseSchema;
